import { updateEmailRecipient } from "../../../../../actions/Utilities/EmailRecipient";
import { useMutation } from "react-query";

const useUpdateEmailRecipient = () => {
  return useMutation(updateEmailRecipient);
};
export default useUpdateEmailRecipient;
